/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthScoreModule
 */

import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import * as globalL10n from 'global-l10n';
import * as l10n from './avi-health-score-error.l10n';
import './avi-health-score-error.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description Component for rendering the error message for health score.
 * @author Nitesh Kesarkar
 */
@Component({
    selector: 'avi-health-score-error',
    templateUrl: './avi-health-score-error.component.html',
})
export class AviHealthScoreErrorComponent {
    /**
     * Fires on click of retry button.
     */
    @Output()
    public onRetryClick = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Trigger retry click event.
     */
    public handleRetry(): void {
        this.onRetryClick.emit();
    }
}
